/* Koreachi | product-form.js — quantity stepper, subscribe toggle, AJAX add to cart, gallery */
(function () {
  'use strict';

  function money(cents, format) {
    if (window.Koreachi && window.Koreachi.formatMoney) return window.Koreachi.formatMoney(cents, format);
    return '$' + (cents / 100).toFixed(2);
  }

  class ProductForm extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.form = this.querySelector('form');
      this.qtyInput = this.querySelector('[data-quantity]');
      this.totalDisplay = this.querySelector('[data-total-display]');
      this.compareDisplay = this.querySelector('[data-compare-display]');
      this.unit = parseInt(this.dataset.unitPrice, 10) || 0;
      this.subPct = parseFloat(this.dataset.subDiscount) || 0;
      this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';

      // Quantity stepper
      var down = this.querySelector('[data-qty-down]');
      var up = this.querySelector('[data-qty-up]');
      if (down) down.addEventListener('click', function () { self.stepQty(-1); });
      if (up) up.addEventListener('click', function () { self.stepQty(1); });
      if (this.qtyInput) this.qtyInput.addEventListener('change', function () { self.updatePrice(); });

      // Purchase toggle (one-time / subscribe)
      this.querySelectorAll('[data-purchase] input[type="radio"]').forEach(function (radio) {
        radio.addEventListener('change', function () { self.updatePrice(); });
      });

      if (this.form) {
        this.form.addEventListener('submit', function (e) {
          e.preventDefault();
          self.submit();
        });
      }

      this.updatePrice();
    }

    getQty() {
      var q = parseInt(this.qtyInput ? this.qtyInput.value : 1, 10);
      if (isNaN(q) || q < 1) q = 1;
      return q;
    }

    stepQty(dir) {
      if (!this.qtyInput) return;
      var q = this.getQty() + dir;
      if (q < 1) q = 1;
      this.qtyInput.value = q;
      this.updatePrice();
    }

    isSubscribe() {
      var checked = this.querySelector('[data-purchase] input[type="radio"]:checked');
      return checked && checked.dataset.mode === 'sub';
    }

    updatePrice() {
      if (!this.totalDisplay) return;
      var qty = this.getQty();
      var oneTime = this.unit * qty;
      if (this.isSubscribe() && this.subPct > 0) {
        var perSub = Math.round(this.unit * (1 - this.subPct / 100));
        this.totalDisplay.textContent = money(perSub * qty, this.moneyFormat);
        if (this.compareDisplay) {
          this.compareDisplay.textContent = money(oneTime, this.moneyFormat);
          this.compareDisplay.hidden = false;
        }
      } else {
        this.totalDisplay.textContent = money(oneTime, this.moneyFormat);
        if (this.compareDisplay) this.compareDisplay.hidden = true;
      }
    }

    submit() {
      var self = this;
      var data = new FormData(this.form);
      var id = data.get('id');
      var qty = parseInt(data.get('quantity'), 10) || 1;
      var plan = data.get('selling_plan') || null;
      var btn = this.querySelector('[data-atc]');
      if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Adding...'; }

      var api = window.Koreachi && window.Koreachi.cart;
      var done = function () {
        if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Add to cart'; }
      };

      if (api) {
        api.add(id, qty, plan).then(done).catch(done);
      } else {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: id, quantity: qty, selling_plan: plan })
        }).then(function () { window.location = '/cart'; }).catch(done);
      }
    }
  }
  customElements.define('product-form', ProductForm);

  /* ---- Product gallery: swipe carousel + thumbnail sync ---- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var track = gallery.querySelector('[data-gallery-track]');
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-slide]'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    if (!track || slides.length < 2) return;

    function setActive(index) {
      thumbs.forEach(function (t) {
        t.setAttribute('aria-current', String(Number(t.dataset.goto) === index));
      });
    }

    // Click / keyboard: scroll the carousel to that slide
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var i = Number(thumb.dataset.goto) || 0;
        var slide = slides[i];
        if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        setActive(i);
      });
    });

    // Swipe / scroll: keep the active thumb in sync with the visible slide
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) setActive(Number(entry.target.dataset.index) || 0);
        });
      }, { root: track, threshold: 0.6 });
      slides.forEach(function (s) { io.observe(s); });
    }
  });
})();
